// extracted by mini-css-extract-plugin
module.exports =  {"root":"HuD5j97hEJ4av_GOyBYr"};